import { SortDescriptor } from '@ds';

export const columns = {
  serialNumber: {
    key: 'serialNumber',
    label: 'Serial number',
    isSortable: true,
    minWidthClassName: 'min-w-[200px]',
  },
  organ: {
    key: 'organ',
    label: 'Organ',
    isSortable: false,
    minWidthClassName: 'min-w-[25%]',
  },
  lastInUse: {
    key: 'lastInUse',
    label: 'Last In Use',
    isSortable: false,
    minWidthClassName: 'min-w-[25%]',
  },
  assign: {
    key: 'assign',
    label: '',
    isSortable: false,
    minWidthClassName: 'w-[96px]',
  },
};

export const defaultDeviceSort: SortDescriptor = { column: columns.serialNumber.key, direction: 'ascending' };

export const getOCSColumns = (isSwap?: boolean) => {
  const cols = [columns.serialNumber, columns.organ, columns.lastInUse];

  if (isSwap) {
    cols.unshift(columns.assign);
  } else {
    cols.push(columns.assign);
  }

  return cols;
};
